<form [formGroup]="userAttributesForm" class="main">
    <div class="select-frequency mt-4">Select Frequency</div>
    <div class="frequency-button-container">
        <div class="col" *ngFor="let frequency of frequencies; let i=index">
            <input type="radio" [id]="i+'custom1'" [value]="frequency.value" formControlName="frequency"
                [(ngModel)]="currentFrequency" (change)="onFrequencyChange()">
            <label class="frequency-button" [for]="i+'custom1'">{{frequency.key}}</label>
        </div>
    </div>
    <div *ngIf="userAttributesForm.controls.frequency.invalid">
        <span class="error-text">Please select your nCash frequency</span>
    </div>
    <div class="select-frequency">
        <p>Select the Amount</p>
    </div>
    <div class="max-amount">
        <div class="row display-flex">
            <div class="col-md-6 flex-slider">
                <div class="wrapper-slider">
                    <mat-slider style="width:100%;" [min]="100" [max]="maxNCashAmount"
                        [ngModelOptions]="{standalone: true}" [(ngModel)]="value" [value]="value" (ngModelChange)="changeCustomAmount()">
                    </mat-slider>
                    <div class="slider-label">
                        <span>₹ 100</span>
                        <span>₹ {{maxNCashAmount | number: '1.0-2'}}</span>
                    </div>
                </div>
                <div class="error-wrapper">
                    <p *ngIf="this.excessAmountAllocatedError" class="error-text">Custom nCash amount cannot exceed the Max nCash</p>
                </div>
            </div>
            <div class="col-md-6 text-right mob-view">
                <span class="ncash">nCash ₹</span>
                <input type=number [(ngModel)]="value" [ngModelOptions]="{standalone: true}" [min]="100"
                    [max]="maxNCashAmount" (ngModelChange)="changeCustomAmount()" onKeyPress="if(this.value.length==7) return false;" />
            </div>
        </div>
    </div>
    <div class="note">
        <p>Note: Based on the Frequency selection the Custom nCash amount will change</p>
    </div>
    <div class="select-frequency mt-4">Select Date</div>
    <div class="frequency-button-container">
        <div class="col" *ngFor="let date of dates; let i=index">
            <input type="radio" [id]="i+'custom2'" [value]="date.value" formControlName="date" [(ngModel)]="currentDate"
                (change)="onDateChange()">
            <label class="frequency-button" [for]="i+'custom2'">{{date.key}}<sup>th</sup> of Month</label>
        </div>
    </div>
    <div *ngIf="userAttributesForm.controls.date.invalid">
        <span class="error-text">Please select your nCash date </span>
    </div>
</form>